var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.sign}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}}):_c('span',[_vm._v(" "+_vm._s(_vm.$t( `donation.action_after_belz_doc_signing_btn`, 'sign' ))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }